<div (dragenter)="dragenter($event)"
     (dragover)="dragover($event)">

    <app-component-button-create-fcfv
            *ngIf="isNeedRefreshMediator"
            [isCollection]="isCollection"
            [isCreateCollection]="data.right?.is_upload_file"
            [isCreateFolder]="isCollection && data.right.is_create_folder"
    ></app-component-button-create-fcfv>

    <div (drop)="drop($event, selectSignersView)"
         *ngIf="shadow"
         class="dropArea">
        <h1><i class="bi bi-arrow-down-square-fill"></i> {{ 'DOCUMENTS.TEXT.DROP_FILES' | translate }}</h1>
    </div>
    <div class="flex-display">
        <div style="min-width: 80%;">
            <div *ngIf="data.data.length"
                 style="text-align: end">
                <i (click)="openPersonalViewSettings(personalTableViewSettings)"
                   class="bi bi-gear p-2 me-2"
                   style="cursor: pointer"></i>
            </div>
            <div style="max-width: inherit; overflow: scroll">
                <table class="table gbo_shadow">
                    <thead>
                    <tr>
                        <th>
                            <div (click)="sortBy('name')"
                                 *ngIf="data.pagination"
                                 [class.revers]="data.pagination.sort === 'asc' && data.pagination.sort_by === 'name'"
                                 [class.sorting]="data.pagination.sort_by === 'name'"
                                 data-action="sortByName">
                                <span>{{ 'DOCUMENTS.TITLES.NAME' | translate }}</span>
                                <i
                                        *ngIf="data.pagination.sort_by === 'name'"
                                        [class.icon-down-1]="data.pagination.sort === 'asc'"
                                        [class.icon-up-1]="data.pagination.sort !== 'asc'"></i>
                            </div>
                            <span *ngIf="!data.pagination">{{ 'DOCUMENTS.TITLES.NAME' | translate }}</span>
                        </th>
                        <th *ngIf="view !== 'mini'">
                            <div (click)="sortBy('created_at')"
                                 *ngIf="data.pagination"
                                 [class.revers]="data.pagination.sort === 'asc' && data.pagination.sort_by === 'created_at'"
                                 [class.sorting]="data.pagination.sort_by === 'created_at'"
                                 data-action="cortByCreate">
                                <span>{{ 'DOCUMENTS.TITLES.CREATED_AT' | translate }}</span>
                                <i
                                        *ngIf="data.pagination.sort_by === 'created_at'"
                                        [class.icon-down-1]="data.pagination.sort === 'asc'"
                                        [class.icon-up-1]="data.pagination.sort !== 'asc'"></i>
                            </div>
                            <span *ngIf="!data.pagination">{{ 'DOCUMENTS.TITLES.CREATED_AT' | translate }}</span>
                        </th>
                        <th>
                            <div (click)="sortBy('updated_at')"
                                 *ngIf="data.pagination"
                                 [class.revers]="data.pagination.sort === 'asc' && data.pagination.sort_by === 'updated_at'"
                                 [class.sorting]="data.pagination.sort_by === 'updated_at'"
                                 data-action="sortByUpdate">
                                <span>{{ 'DOCUMENTS.TITLES.UPDATED_AT' | translate }}</span>
                                <i
                                        *ngIf="data.pagination.sort_by === 'updated_at'"
                                        [class.icon-down-1]="data.pagination.sort === 'asc'"
                                        [class.icon-up-1]="data.pagination.sort !== 'asc'"></i>
                            </div>
                            <span *ngIf="!data.pagination">{{ 'DOCUMENTS.TITLES.UPDATED_AT' | translate }}</span>
                        </th>

                        <th *ngIf="view !== 'mini'">
                            <div>
                                <span>{{ 'DOCUMENTS.TITLES.TYPE' | translate }}</span>
                            </div>
                            <span *ngIf="!data.pagination">{{ 'DOCUMENTS.TITLES.TYPE' | translate }}</span>
                        </th>
                        <th>
                            {{ 'DOCUMENTS.TITLES.CUSTOM_PROPERTY' | translate }}
                        </th>
                    </tr>
                    </thead>
                    <tbody *ngIf="!data.loading; else loading">
                    <ng-container>
                        <tr (click)="onBack()"
                            *ngIf="data.folder && showBackButton"
                            class="table-item back"
                            data-action="goBack">
                            <td colspan="6">
                                <div class="icon">
                                    <i class="icon-up"></i>
                                    <span> {{ 'DOCUMENTS.TEXT.BACK' | translate }} ({{ data.folder.name }})</span>
                                </div>
                            </td>
                        </tr>

                        <tr *ngFor="let item of data.data; let i = index"
                            [attr.data-index]="i"
                            [attr.data-type]="item.type_str"
                            [class]="{'table-item': true, is_selected: itemIsSelected(item), item_selected: item.selected}">
                            <td (click)="onSelect(item)"
                                data-action="selectItem">
                                <div style="width: max-content">
                                    <i *ngIf="item.type_str === 'folder'"
                                       class="icon-folder"></i>
                                    <i *ngIf="item.type_str === 'file'"
                                       class="icon-file"></i>
                                    <i *ngIf="item.type_str === 'collection'"
                                       class="icon-bookmarks"></i>
                                    #{{ i + 1 }}. <strong>{{ item.name }}</strong>
                                </div>
                                <div *ngIf="view !== 'mini'"
                                     [innerHtml]="item.description"></div>
                            </td>
                            <td (click)="onSelect(item)"
                                *ngIf="view !== 'mini'">{{ item.created_at | date:'HH:mm dd.MM.yyyy' }}
                            </td>
                            <td (click)="onSelect(item)"
                                *ngIf="view !== 'mini'">{{ item.updated_at ? (item.updated_at | date:'HH:mm dd.MM.yyyy') : '-' }}
                            </td>
                            <td (click)="onSelect(item)"
                                *ngIf="view === 'mini'">
                                {{ item.created_at | date:'HH:mm dd.MM.yyyy' }}
                                / {{ item.updated_at | date:'HH:mm dd.MM.yyyy' }}
                            </td>
                            <td>
                                <div>
                                    <label class="badge text-bg-info">[ {{ 'DOCUMENTS.TEXT.TYPES.' + item.type_str | translate }}
                                        ]</label>
                                </div>
                            </td>
                            <td (click)="onSelect(item)">
                                <span *ngIf="(!item.custom_properties ||
                                                !(item.custom_properties && item.custom_properties.length)) ||
                                                currentSettings[item.type_str].length === item.custom_properties.length"
                                >-</span>
                                <div *ngIf="item?.custom_properties?.length">
                                    <table>
                                        <thead>
                                        <tr>
                                            <td *ngFor="let property of item.custom_properties"
                                                [class.display-none]="currentSettings[item.type_str].includes(property.property.id)">
                                                <i [class]="propertyIcon[property.property.property_type].icon"
                                                   [ngbTooltip]=" 'PROPERTIES.TOOLTIPS.' +
                                                                propertyIcon[property.property.property_type].tooltip | translate "
                                                   class="me-1"
                                                ></i>
                                                <strong class="me-1">{{ property.property.title }}</strong>
                                            </td>
                                        </tr>
                                        </thead>
                                        <tbody>

                                        <tr>
                                            <td *ngFor="let property of item.custom_properties"
                                                [class.display-none]="currentSettings[item.type_str].includes(property.property.id)">
                                                <ng-container
                                                        *ngTemplateOutlet="propTemplates; context: {props: property}">
                                                </ng-container>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>


                                    <ng-template #propTemplates
                                                 let-props="props">
                                        <ng-container [ngSwitch]="props.property.property_type">
                                            <ng-template ngSwitchCase="property_file">
                                                <div *ngIf="props.property.is_multiform ? props.property_values.length :
                                                            props.property_values; else emptyTemplate"
                                                >
                                                    <div *ngIf="props.property.is_multiform">
					                            <span *ngFor="let value of props.property_values; let i = index">
						                        <span *ngIf="i !== 0"
                                                      class="me-1">,</span>
                                                    {{ value.name }}
					                            </span>
                                                    </div>
                                                    <div *ngIf="!props.property.is_multiform">
					                            <span>
						                            {{ props.property_values.name }}
					                            </span>
                                                    </div>
                                                </div>
                                            </ng-template>

                                            <ng-template ngSwitchCase="property_member">
                                                <div *ngIf="props.property.is_multiform ? props.property_values.length :
                                                            props.property_values; else emptyTemplate">
                                                    <div *ngIf="props.property.is_multiform">
					                            <span *ngFor="let value of props.property_values; let i = index">
						                            <span *ngIf="i !== 0"
                                                          class="me-1">,</span>
                                                    <span (click)="openProfile($event, value)"
                                                          class="user_name">
								                        {{ helper.fullName(value) }}
							                        </span>
                                                </span>
                                                    </div>
                                                    <div *ngIf="!props.property.is_multiform">
					                            <span (click)="openProfile($event, props.property_values)"
                                                      class="user_name">
						                            {{ helper.fullName(props.property_values) }}
					                            </span>
                                                    </div>
                                                </div>
                                            </ng-template>

                                            <ng-template ngSwitchCase="property_text">
                                                <div>
                                                    <span *ngIf="props.property_values; else emptyTemplate">
                                                        {{ props.property_values }}
                                                    </span>
                                                </div>
                                            </ng-template>

                                            <ng-template ngSwitchCase="property_boolean">
                                                <div *ngIf="props.property_values; else emptyTemplate">
                                                    <span>
                                                        {{
                                                            (props.property_values ? 'PROPERTIES.VALUES.TRUE' :
                                                                'PROPERTIES.VALUES.FALSE') | translate
                                                        }}
                                                    </span>
                                                </div>
                                            </ng-template>

                                            <ng-template ngSwitchCase="property_catalog">
                                                <div *ngIf="props.property.is_multiform ? props.property_values.length :
                                                            props.property_values; else emptyTemplate">
                                                    <div *ngIf="props.property.is_multiform">
					                                    <span *ngFor="let value of props.property_values; let i = index">
						                                    <span *ngIf="i !== 0"
                                                                  class="me-1">,</span>
                                                            {{ value.items_text }}
					                                    </span>
                                                    </div>
                                                    <div *ngIf="!props.property.is_multiform">
					                                    <span>
						                                    {{ props.property_values.items_text }}
					                                    </span>
                                                    </div>
                                                </div>
                                            </ng-template>

                                            <ng-template ngSwitchCase="property_todo">
                                                <div *ngIf="props.property_values.length; else emptyTemplate">
                                                    <div>
					                                    <span *ngFor="let value of props.property_values; let i = index">
						                                <span *ngIf="i !== 0"
                                                              class="me-1">,</span>
                                                            {{ value.items_text }}
					                                    </span>
                                                    </div>
                                                </div>
                                            </ng-template>


                                            <ng-template #emptyTemplate>
                                                <span>{{ 'PROPERTIES.VALUES.EMPTY' | translate }}</span>
                                            </ng-template>
                                        </ng-container>
                                    </ng-template>

                                </div>
                            </td>
                            <td>
                                <div style="width: max-content">
                                    <a (click)="openPropertiesModal(item, itemPropertiesSet)"
                                       *ngIf="item?.custom_properties?.length"
                                       class="btn button-icon-info "
                                       data-action="openSetPropModal"
                                       style="padding: 5px 10px; margin-left: 5px"
                                    >
                                        <i class="bi bi-info-circle"></i>
                                    </a>

                                    <a (click)="deleteItem(item)"
                                       *ngIf="data.pagination.filter === 'all' && data.right.is_delete && item.type_str === 'folder'"
                                       class="btn button-icon-delete text-white-50"
                                       style="padding: 5px 10px; margin-left: 5px;">
                                        <i class="bi bi-trash"></i>
                                    </a>
                                    <a (click)="deleteItem(item)"
                                       *ngIf="data.pagination.filter === 'all' && data.right.is_delete &&
                                                item.type_str === 'file' && item.can_be_deleted && !data.folder.is_locked"
                                       class="btn button-icon-delete text-white-50"
                                       style="padding: 5px 10px; margin-left: 5px;">
                                        <i class="bi bi-trash"></i>
                                    </a>
                                    <a (click)="deleteItem(item)"
                                       *ngIf="data.pagination.filter === 'all' &&
                                                data.right.is_delete &&
                                                item.type_str === 'collection' &&
                                                !item.is_locked &&
                                                (item.signed_documents.split('/')[0] !==
                                                item.signed_documents.split('/')[1] ||
                                                item.signed_documents.split('/')[1] === '0')"
                                       class="btn button-icon-delete text-white-50"
                                       data-action="deleteItem"
                                       style="padding: 5px 10px; margin-left: 5px;">
                                        <i class="bi bi-trash"></i>
                                    </a>
                                </div>
                            </td>
                        </tr>

                        <tr *ngIf="!data.data.length"
                            class="table-warning">
                            <td colspan="6">{{ 'EMPTY_LISTS.DOCS' | translate }}</td>
                        </tr>

                    </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
        <div *ngIf="data.folder && view !== 'mini' && data.folder.custom_properties && data.folder.custom_properties.length"
             style="width: 20%; margin: 15px">
            <h2>{{ 'DOCUMENTS.TEXT.FIELDS' | translate }} {{ data.folder.name }}</h2>
            <app-detail-property
                    (refreshEmit)="afterRefresh()"
                    [canEdit]="data.right.is_edit_property"
                    [customProperties]="data.folder.custom_properties"
                    [targetKey]="data.folder.key ? data.folder.key : data.folder.id"

                    [target]="data.folder.type_str"
            ></app-detail-property>
        </div>
    </div>

    <div *ngIf="data && data.pagination"
         style="padding-left: 5px; padding-bottom: 15px">
        <app-component-pagination (page)="setPage($event)"
                                  [pagination]="data.pagination"></app-component-pagination>
    </div>
</div>

<ng-template #loading>
    <tr>
        <td colspan="4">
            <app-component-loading></app-component-loading>
        </td>
    </tr>
</ng-template>

<ng-template #selectSignersView
             let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h2>{{ 'MODALS.HEADERS.UPLOAD_FILES' | translate }}</h2>

        <h2>{{ 'MODALS.FIELDS.FILES' | translate }}:</h2>
        <div *ngFor="let file of files; let i = index"
             class="mb-2">
            <span>#{{ i + 1 }} <i class="bi bi-file-arrow-up"></i> {{ file.name }}</span>
        </div>

        <h2>{{ 'MODALS.FIELDS.SIGNERS' | translate }}</h2>
        <select #memberKey
                (change)="deleteOrSetSigners(memberKey.value)"
                class="form-select">
            <option hidden
                    selected
                    value="">{{ 'MODALS.FIELDS.SELECT.MEMBER' | translate }}
            </option>
            <option *ngIf="!allMembers.length"
                    disabled>{{ 'EMPTY_LISTS.EMPTY' | translate }}
            </option>
            <option *ngFor="let member of allMembers"
                    [value]="member.guid"
            >
                {{ helper.fullName(member) }}
            </option>
        </select>
        <p><small> {{ 'MODALS.TEXT.SIGNER' | translate }} </small></p>
        <label *ngIf="!isCollection">
            <input #oneCollection
                   (change)="isChecked = oneCollection.checked"
                   [checked]="isChecked"
                   style="width: auto;"
                   type="checkbox">
            {{ 'MODALS.FIELDS.ONE_COLLECTION' | translate }}?
        </label>
        <div class="list-group">
            <div *ngFor="let signer of signers"
                 class="list-group-item list-group-item-action "
                 style="display: flex">
                <div (click)="helper.openProfileByGuid(signer.guid)"
                     style="width: 100%">
                    <span class="pointer">{{ helper.fullName(signer) }}</span>
                </div>
                <i (click)="deleteOrSetSigners(signer.guid)"
                   class="bi bi-trash"
                   style="color: red; float: right; cursor: pointer"
                ></i>
            </div>
        </div>

        <div>
            <button (click)="uploadFiles(modal);"
                    class="btn btn-success mt-2"
                    data-action="createFile"
            >
                {{ 'MODALS.BUTTONS.UPLOAD' | translate }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #itemPropertiesSet
             let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <app-detail-property
                (refreshEmit)="afterRefresh()"
                [customProperties]="selectedItem.custom_properties"
                [targetKey]="selectedItem.key ? selectedItem.key : selectedItem.id"

                [target]="selectedItem.type_str"
        ></app-detail-property>
    </div>
</ng-template>

<ng-template #personalTableViewSettings
             let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h2>{{ 'MODALS.HEADERS.SETTING_FILES' | translate }}</h2>
        <div *ngIf="templateItemForSettings.custom_properties && templateItemForSettings.custom_properties.length"
             class="status_container list-group">
            <a *ngFor="let prop of templateItemForSettings.custom_properties"
               class="list-group-item list-group-item-action flex-display"
            >
                <div style="width: 70%;">
                    <i [class]="propertyIcon[prop.property.property_type].icon"
                       [ngbTooltip]="'PROPERTIES.TOOLTIP' + propertyIcon[prop.property.property_type].tooltip | translate"
                       style="margin-right: 5px; font-size: 20px;"></i>
                    {{ prop.property.title }}
                </div>

                <div (click)="changeVision(prop)"
                     style="display: block ruby; cursor: pointer">
                        <span *ngIf="!currentSettings[templateItemForSettings.type_str].includes(prop.property.id)"
                              class="text-success"><i
                                class="bi bi-eye-fill text-success"></i> {{ 'MODALS.FIELDS.VISIBLE_FIELD' | translate }}</span>
                    <span *ngIf="currentSettings[templateItemForSettings.type_str].includes(prop.property.id)"
                          class="text-secondary"><i
                            class="bi bi-eye-slash-fill text-secondary"></i><s> {{ 'MODALS.FIELDS.HIDE_FIELD' | translate }}</s></span>
                </div>
            </a>
        </div>
        <div *ngIf="!templateItemForSettings.custom_properties.length">
            {{ 'EMPTY_LISTS.PROPERTIES.EMPTY' | translate }}
        </div>
    </div>
</ng-template>
